export const API_URL = import.meta.env.DEV
    ? "/api"
    : `${window.location.origin}/api`;
